import { render, staticRenderFns } from "./SDetailProductComp.vue?vue&type=template&id=4d1e1acc&"
import script from "./SDetailProductComp.vue?vue&type=script&lang=js&"
export * from "./SDetailProductComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports